"use strict";
var uncurryThis = require("../internals/function-uncurry-this");
var defineBuiltIn = require("../internals/define-built-in");
var DatePrototype = Date.prototype;
var INVALID_DATE = "Invalid Date";
var TO_STRING = "toString";
var nativeDateToString = uncurryThis(DatePrototype[TO_STRING]);
var thisTimeValue = uncurryThis(DatePrototype.getTime);
if (String(/* @__PURE__ */ new Date(NaN)) !== INVALID_DATE) {
  defineBuiltIn(DatePrototype, TO_STRING, function toString() {
    var value = thisTimeValue(this);
    return value === value ? nativeDateToString(this) : INVALID_DATE;
  });
}
